import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mt-2 time-table" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col\"><ul class=\"list-group header\"><li class=\"list-group-item active\">Last content check</li><li class=\"list-group-item active\">Download began at</li><li class=\"list-group-item active\">Download completed at</li><li class=\"list-group-item active\">Download start time</li><li class=\"list-group-item active\">Download end time</li><li class=\"list-group-item active\">Last error at</li><li class=\"list-group-item active\">Last hearbit at</li><li class=\"list-group-item active\">Last modify</li><li class=\"list-group-item active\">Last sync specification</li><li class=\"list-group-item active\">Uptime</li></ul></div>", 1)
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "list-group row" }
const _hoisted_6 = { class: "list-group-item" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "list-group" }
const _hoisted_9 = { class: "list-group-item" }

import { computed } from "vue";
import moment from "moment";
import { timeSpanFormat } from "@/services/format.service"


export default /*#__PURE__*/_defineComponent({
  name: 'player-timechecks.component',
  props: {
  player: Object,
},
  setup(__props) {

const props = __props



const data = computed(() => {
  const dateFormat = "DD/MM/YY H:mm:ss";

  const {
    LastContentCheckTime,
    LastContentDownloadStartTime,
    LastContetnDownloadEndTime,
    LastErrorTime,
    LastHeartbeatTime,
    LastModifiedDate,
    LastSyncSpecProcessedTime,
  } = props.player as any;

  let { Uptime, ContentDownloadsStartTime, ContentDownloadsEndTime } = props.player as any;

  Uptime = Uptime != undefined ? timeSpanFormat(Uptime) : '???'
  ContentDownloadsStartTime = ContentDownloadsStartTime != undefined ? 
  timeSpanFormat(ContentDownloadsStartTime) + '00' : '???'
  ContentDownloadsEndTime = ContentDownloadsEndTime != undefined ? 
  timeSpanFormat(ContentDownloadsEndTime) + '00' : '???'

  return {
    moment: {
      LastContentCheckTime: moment(LastContentCheckTime).fromNow(),
      LastContentDownloadStartTime: moment(
        LastContentDownloadStartTime
      ).fromNow(),
      LastContetnDownloadEndTime:
        LastContetnDownloadEndTime != undefined
          ? moment(LastContetnDownloadEndTime).fromNow()
          : "???",
      ContentDownloadsStartTime,
      ContentDownloadsEndTime,
      LastErrorTime: moment(LastErrorTime).fromNow(),
      LastHeartbeatTime: moment(LastHeartbeatTime).fromNow(),
      LastModifiedDate: moment(LastModifiedDate).fromNow(),
      LastSyncSpecProcessedTime: moment(LastSyncSpecProcessedTime).fromNow(),
      Uptime
    },
    pure: {
      LastContentCheckTime: moment(LastContentCheckTime).format(dateFormat),
      LastContentDownloadStartTime: moment(LastContentDownloadStartTime).format(
        dateFormat
      ),
      LastContetnDownloadEndTime:
        LastContetnDownloadEndTime != undefined
          ? moment(LastContetnDownloadEndTime).format(dateFormat)
          : "???",
      ContentDownloadsStartTime: props.player?.ContentDownloadsStartTime,
      ContentDownloadsEndTime: props.player?.ContentDownloadsEndTime,
      LastErrorTime: moment(LastErrorTime).format(dateFormat),
      LastHeartbeatTime: moment(LastHeartbeatTime).format(dateFormat),
      LastModifiedDate: moment(LastModifiedDate).format(dateFormat),
      LastSyncSpecProcessedTime: moment(LastSyncSpecProcessedTime).format(
        dateFormat
      ),
      Uptime: props.player?.Uptime,
    },
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _cache[0] || (
            _setBlockTracking(-1),
            _cache[0] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastContentCheckTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[0]
          ),
          _cache[1] || (
            _setBlockTracking(-1),
            _cache[1] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastContentDownloadStartTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[1]
          ),
          _cache[2] || (
            _setBlockTracking(-1),
            _cache[2] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastContetnDownloadEndTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[2]
          ),
          _cache[3] || (
            _setBlockTracking(-1),
            _cache[3] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.ContentDownloadsStartTime ? _unref(data).pure.ContentDownloadsStartTime : '???'), 1)
            ]),
            _setBlockTracking(1),
            _cache[3]
          ),
          _cache[4] || (
            _setBlockTracking(-1),
            _cache[4] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.ContentDownloadsEndTime ? _unref(data).pure.ContentDownloadsEndTime : '???'), 1)
            ]),
            _setBlockTracking(1),
            _cache[4]
          ),
          _cache[5] || (
            _setBlockTracking(-1),
            _cache[5] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastErrorTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[5]
          ),
          _cache[6] || (
            _setBlockTracking(-1),
            _cache[6] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastHeartbeatTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[6]
          ),
          _cache[7] || (
            _setBlockTracking(-1),
            _cache[7] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastModifiedDate), 1)
            ]),
            _setBlockTracking(1),
            _cache[7]
          ),
          _cache[8] || (
            _setBlockTracking(-1),
            _cache[8] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).pure.LastSyncSpecProcessedTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[8]
          ),
          _createElementVNode("li", _hoisted_6, _toDisplayString(_unref(data).pure.Uptime), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _cache[9] || (
            _setBlockTracking(-1),
            _cache[9] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastContentCheckTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[9]
          ),
          _cache[10] || (
            _setBlockTracking(-1),
            _cache[10] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastContentDownloadStartTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[10]
          ),
          _cache[11] || (
            _setBlockTracking(-1),
            _cache[11] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastContetnDownloadEndTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[11]
          ),
          _cache[12] || (
            _setBlockTracking(-1),
            _cache[12] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.ContentDownloadsStartTime ? _unref(data).moment.ContentDownloadsStartTime : '???'), 1)
            ]),
            _setBlockTracking(1),
            _cache[12]
          ),
          _cache[13] || (
            _setBlockTracking(-1),
            _cache[13] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.ContentDownloadsEndTime ? _unref(data).moment.ContentDownloadsEndTime : '???'), 1)
            ]),
            _setBlockTracking(1),
            _cache[13]
          ),
          _cache[14] || (
            _setBlockTracking(-1),
            _cache[14] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastErrorTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[14]
          ),
          _cache[15] || (
            _setBlockTracking(-1),
            _cache[15] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastHeartbeatTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[15]
          ),
          _cache[16] || (
            _setBlockTracking(-1),
            _cache[16] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastModifiedDate), 1)
            ]),
            _setBlockTracking(1),
            _cache[16]
          ),
          _cache[17] || (
            _setBlockTracking(-1),
            _cache[17] = _createElementVNode("li", { class: "list-group-item" }, [
              _createTextVNode(_toDisplayString(_unref(data).moment.LastSyncSpecProcessedTime), 1)
            ]),
            _setBlockTracking(1),
            _cache[17]
          ),
          _createElementVNode("li", _hoisted_9, _toDisplayString(_unref(data).moment.Uptime), 1)
        ])
      ])
    ])
  ]))
}
}

})